import { v4 as uuidv4 } from 'uuid'
import { CXF } from '@goodgamestudios/cxf-runtime'

import {
  EventTracker,
  ST_AD_LOADED,
  ST_AD_POPUP_SHOWN,
  AC_AD_POPUP_SHOP_LINK_CLICK,
  // @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module '@lem... Remove this comment to see the full error message
} from '@lemonstand.org/unified-tracking/browser'

import log from './utils/logger'
import { bannerType, bannerTypes } from './constants'

const eventTracker = new EventTracker(process.env.TRACKING_SERVICE_URL)

const SESSION_ID = uuidv4()

const GGS_BACKFILL_ORDER_IDS = [2_866_122_916]
const UNREGISTERED_ACTIONTYPE_ID = -5

interface CommonTrackingData {
  date: string
  zoneId: string
  gameId: number
  networkId: number
  instanceId: string
  playerId: string
  sessionId: string
}

let cxf: CXF
let commonTrackingEventData: CommonTrackingData

export const actionTypes = {
  BANNER_ACTIVE: 'banner_active',
  BANNER_INACTIVE: 'banner_inactive',
  BANNER_CLICKED: 'banner_clicked',
  BANNER_REFRESHED: 'banner_refreshed',
} as const

export type typeActionTypes = typeof actionTypes
export type ActionType = typeActionTypes[keyof typeActionTypes]

const HORIZONTAL_ACTION_TO_ID_MAP = new Map([
  [actionTypes.BANNER_ACTIVE, 16],
  [actionTypes.BANNER_INACTIVE, 17],
  [actionTypes.BANNER_CLICKED, 18],
  [actionTypes.BANNER_REFRESHED, 19],
])

const VERTICAL_ACTION_TO_ID_MAP = new Map([
  [actionTypes.BANNER_ACTIVE, 7],
  [actionTypes.BANNER_INACTIVE, 8],
  [actionTypes.BANNER_CLICKED, 9],
  [actionTypes.BANNER_REFRESHED, 10],
])

const BANNER_TYPE_MAP = new Map([
  [bannerTypes.HORIZONTAL_BANNER, HORIZONTAL_ACTION_TO_ID_MAP],
  [bannerTypes.VERTICAL_BANNER, VERTICAL_ACTION_TO_ID_MAP],
])

const GGS_BACKFILL = 'ggs_backfill'

const init = (cxfInst: CXF) => {
  log('tracking has been initialized %o', cxfInst)
  cxf = cxfInst
}

export const setTrackingCommonData = () => {
  commonTrackingEventData = {
    get date() {
      return new Date().toUTCString()
    },
    zoneId: cxf.zoneId,
    gameId: Number.parseInt(cxf.gameId, 10),
    networkId: Number.parseInt(cxf.networkId, 10),
    instanceId: cxf.instanceId,
    playerId: cxf.playerId,
    sessionId: SESSION_ID,
  }
}

export const trackIga = (actionType: ActionType, bannerType: bannerType, parameters?: Record<string, unknown>) => {
  const actionTypeMapping = BANNER_TYPE_MAP.get(bannerType)
  const actionTypeValue = actionTypeMapping?.get(actionType) || UNREGISTERED_ACTIONTYPE_ID

  const impressionId = parameters && parameters.impression_id

  // TODO: refactor optional parameters in the unified tracking project
  return eventTracker.send(
    ST_AD_LOADED.decorate(commonTrackingEventData, actionTypeValue, undefined, undefined, undefined, impressionId)
  )
}

export const trackPopupShown = () => {
  const POPUP_NAME = 'google_adblocker'

  return eventTracker.send(ST_AD_POPUP_SHOWN.decorate(commonTrackingEventData, POPUP_NAME))
}

export const trackPopupShopLinkClicked = () => {
  const POPUP_NAME = 'google_adblocker'
  const POPUP_DETAIL = 'link_to_igs'

  return eventTracker.send(AC_AD_POPUP_SHOP_LINK_CLICK.decorate(commonTrackingEventData, POPUP_NAME, POPUP_DETAIL))
}

const getBannerRefreshTrackedParameters = (gptEvent: googletag.events.SlotRenderEndedEvent) => {
  const result: { impression_id?: string } = {}

  if (gptEvent.campaignId && GGS_BACKFILL_ORDER_IDS.includes(gptEvent.campaignId)) {
    // eslint-disable-next-line camelcase
    result.impression_id = GGS_BACKFILL
  }

  return result
}

export { getBannerRefreshTrackedParameters, init }

export const __internal = {
  GGS_BACKFILL_ORDER_IDS,
  GGS_BACKFILL,
  BANNER_TYPE_MAP,
}
